import { render } from "./WizardItem.vue?vue&type=template&id=3ef94fc2&scoped=true&ts=true"
import script from "./WizardItem.vue?vue&type=script&lang=ts"
export * from "./WizardItem.vue?vue&type=script&lang=ts"

import "./WizardItem.vue?vue&type=style&index=0&id=3ef94fc2&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef94fc2"]])

export default __exports__